import BaseAuthenticationModel from "scripts/models/baseAuthenticationModel";

class OrganizationVerificationAuthenticationModel extends BaseAuthenticationModel {}

export default OrganizationVerificationAuthenticationModel;
